export default __webpack_public_path__ + "static/day-13-1886a45b8279097fbc39ad6cf49ce100.gif";